<app-base-loading-button-modal
  modalTitle="Add a Designated Unit"
  i18n-modalTitle
  primaryLabel="Add Designated Unit"
  i18n-primaryLabel
  secondaryLabel="Back"
  i18n-secondaryLabel
  [isLoading]="isLoading$ | async"
  (primaryClicked)="continue()"
  (closeClicked)="cancel()"
  (secondaryClicked)="goBack()">
  <div class="d-flex flex-column" [style.gap.rem]="2">
    <app-create-designated-unit-required-contributions-form
      [formGroup]="formGroup.controls.contributionDetails"
      [formSubmitted]="formSubmitted"
      [basisForContributionRatesDropdownItems]="basisForContributionRatesDropdownItems$ | async"
      [rateCalculationDropdownItems]="contributionRateCalculationDropdowns$ | async" />
    <hr class="no-margin" />
    <app-create-designated-unit-employee-participation-form
      [formGroup]="formGroup.controls.contributionDetails"
      [formSubmitted]="formSubmitted"
      [lessThanFullTimeParticipationDropdownItems]="lessThanFullTimeParticipationDropdowns$ | async" />
  </div>
</app-base-loading-button-modal>
